export default "__VITE_ASSET__CEIrlgWR__"